import ApiService from "@/core/services/api.service";
// action types
export const GET_CONFIGURACIONES = "getConfiguraciones";
export const GET_CONFIGURACION = "getConfiguracion";
export const CREATE_CONFIGURACION = "creategetConfiguracion";
export const UPDATE_CONFIGURACION = "updateConfiguracion";
export const DELETE_CONFIGURACION = "deteleConfiguracion"
// mutation types
export const SET_CONFIGURACIONES = "setConfiguraciones";
export const SET_CONFIGURACION = "setConfiguracion";
export const SET_ERROR = "setError";

const state = {
  errors: [],
  configuraciones: [],
  configuracion: {},
};

const actions = {
  [GET_CONFIGURACIONES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({ action: `/api/Configuracion/v1/configuraciones` }, '')
        .then(({ data }) => {
          context.commit(SET_CONFIGURACIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },

  [GET_CONFIGURACION](context, codigo) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({ action: `/api/Configuracion/v1/configuracion/${codigo}` }, '')
        .then(({ data }) => {
          context.commit(SET_CONFIGURACION, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },

  [CREATE_CONFIGURACION](context, company) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post({ action: `/api/Configuracion/v1/configuracion` }, company)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [UPDATE_CONFIGURACION](context, configuracion) {
    return new Promise((resolve, reject) => {
      console.log(configuracion)
      ApiService.put({ action: `/api/Configuracion/v1/configuracion/${configuracion.codigo}`}, configuracion)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [DELETE_CONFIGURACION](context, configuracionListaNegraId) {
    return new Promise((resolve, reject) => {
      ApiService.delete({ action: `/api/Configuracion/v1/configuracion/${configuracionListaNegraId}` }, '')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },



};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_CONFIGURACIONES](state, data) {
    state.error = {};
    state.configuraciones = data;
  },
  [SET_CONFIGURACION](state, data) {
    state.error = {};
    state.configuracion = data;
  },
};

export default {
  state,
  actions,
  mutations
};
